import React from 'react';
import {useControllerProps} from '../../ControllerContext';
import {ShippingSectionText} from './ShippingSectionText';
import {getFormattedAddressTranslation} from '../../../addressUtils';
import {useTranslation} from 'yoshi-flow-editor-runtime';

export enum PickupColumnDataHook {
  root = 'PickupColumnColumnDataHook.root',
  title = 'PickupColumnColumnDataHook.title',
  fullName = 'PickupColumnColumnDataHook.fullName',
  address = 'PickupColumnColumnDataHook.address',
  phone = 'PickupColumnColumnDataHook.phone',
}

export const PickupColumn = () => {
  const {t} = useTranslation();
  const {buyerName, pickupAddress, billingAddress, pickupTitle} = useControllerProps().thankYouPageStore;

  const {addressLine, city, country, zipCode} = pickupAddress;

  const addressData = getFormattedAddressTranslation({addressLine1: addressLine, country, city, zipCode}, t);

  return (
    <div data-hook={PickupColumnDataHook.root}>
      <ShippingSectionText dataHook={PickupColumnDataHook.title} text={pickupTitle} isTitle={true} />
      <ShippingSectionText dataHook={PickupColumnDataHook.fullName} text={buyerName} />
      <ShippingSectionText dataHook={PickupColumnDataHook.address} text={addressData} />
      <ShippingSectionText dataHook={PickupColumnDataHook.phone} text={billingAddress?.phoneNumber} />
    </div>
  );
};
